// extracted by mini-css-extract-plugin
export var changeIcon = "_4q-4";
export var container = "_4q-0";
export var divider = "_4q-7";
export var externalLinkIcon = "_4q-1";
export var green = "_4q-5";
export var helpCircleIcon = "_4q-3";
export var iconButton = "_4q-2";
export var red = "_4q-6";